<app-top-nav></app-top-nav>
<mat-drawer-container class="container" hasBackdrop="false">
  <mat-drawer-content>
    <app-side-nav [showBanner]="commonUtils.showBanner()">
      <router-outlet></router-outlet>
    </app-side-nav>
  </mat-drawer-content>
</mat-drawer-container>

@if (commonUtils.showLoadingModal()) {
  <app-loading-modal></app-loading-modal>
}
